/*
 * schemas Reducer
 */
import get from 'lodash.get';

import { SCAFFOLD_DATA_LOAD_SUCCEEDED } from '../scaffoldData/constants';
import { RESET_STATE } from '../auth/constants';
import {
    SET_SCHEMA,
    SET_SCHEMA_ENABLED,
    SET_SCHEMA_DISABLED
} from './constants';

const initialState = {};

export default function(state = initialState, action) {
    switch (action.type) {
        case SCAFFOLD_DATA_LOAD_SUCCEEDED: {
            const schemas = get(action, 'payload.entities.schemas', {});
            return {
                ...schemas
            };
        }
        case SET_SCHEMA:
            return {
                ...state,
                [action.payload.schemaId]: action.payload.data
            };
        case SET_SCHEMA_ENABLED:
            return {
                ...state,
                [action.payload.schemaId]: {
                    ...state[action.payload.schemaId],
                    isEnabled: true
                }
            };
        case SET_SCHEMA_DISABLED:
            return {
                ...state,
                [action.payload.schemaId]: {
                    ...state[action.payload.schemaId],
                    isEnabled: false
                }
            };
        case RESET_STATE:
            return initialState;
        default:
            return state;
    }
}
